<template>
    <base-section
    id="san-andres"
    >
      <v-container>
      <base-section-heading
      title="Welcome to San Andrés Island!"
      color="secondary"
      align="left"
      :toColor="true"
      >
      San Andrés Island is a beautiful Caribbean Island and a part of Colombia. San Andrés is located in the Caribbean Sea, and it is part of an archipelago that also includes Providencia and Santa Catalina islands. The island boasts pristine white sandy beaches, crystal-clear turquoise waters, and vibrant coral reefs. The marine biodiversity around the island is exceptional, making it a haven for snorkelers and divers. The culture of San Andrés is a unique blend of Colombian, Afro-Caribbean, and English influences, producing very particular music, cuisine, and island ‘s traditions San Andrés Island offers a perfect blend of natural beauty, cultural richness, and recreational opportunities, making it a sought-after destination for travellers seeking a Caribbean getaway with a Colombian twist.
<br><br>
Below you can download an useful guide with tips and tricks to travel to San Andrés!
<br><br>
<v-btn
    href="/LATS2025/LATS2025_Travel_Book.pdf"
    rounded
    color="primary"
    dark
    download
    style="padding: 15px"
>
    <v-icon
    left
    dark
    >
    mdi-file-download
    </v-icon>
    Travel Book
    </v-btn>
<br><br>
<flipbook
:pages="pages"
class="flipbook"
v-slot="flipbook"
:gloss="0.7"
>
<div class="action-bar">
<left-icon
  class="btn float-left"
  :class="{ disabled: !flipbook.canFlipLeft }"
  @click="flipbook.flipLeft"
/>
<plus-icon
  class="btn plus"
  :class="{ disabled: !flipbook.canZoomIn }"
  @click="flipbook.zoomIn"
/>
<span class="page-num">
  Page {{ flipbook.page }} of {{ flipbook.numPages }}
</span>
<minus-icon
  class="btn minus"
  :class="{ disabled: !flipbook.canZoomOut }"
  @click="flipbook.zoomOut"
/>
<right-icon
  class="btn float-right"
  :class="{ disabled: !flipbook.canFlipRight }"
  @click="flipbook.flipRight"
/>
</div>
</flipbook>
<br><br>
<div
class="d-flex justify-center"
>
      <iframe
      src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7284137123010514944?compact=1"
      height="800"
      width="500"
      frameborder="0"
      allowfullscreen=""
      allow="autoplay"
      title="San Andrés"
      >
    </iframe>
</div>
    </base-section-heading>
      </v-container>
    </base-section>
  </template>

  <script>
  import LeftIcon from 'vue-material-design-icons/ChevronLeftCircle'
  import RightIcon from 'vue-material-design-icons/ChevronRightCircle'
  import PlusIcon from 'vue-material-design-icons/PlusCircle'
  import MinusIcon from 'vue-material-design-icons/MinusCircle'
  import Flipbook from 'flipbook-vue/dist/vue2/flipbook.cjs'
import { flip } from 'lodash'
    export default {
      name: 'SanAndres',
      components: { Flipbook, LeftIcon, RightIcon, PlusIcon, MinusIcon },
      data: () => ({
        slides: [

        ],
        pages: [
          null, require('@/assets/travel_book_images/page-01.png'), require('@/assets/travel_book_images/page-02.png'), require('@/assets/travel_book_images/page-03.png'), require('@/assets/travel_book_images/page-04.png'), require('@/assets/travel_book_images/page-05.png'), require('@/assets/travel_book_images/page-06.png'), require('@/assets/travel_book_images/page-07.png'), require('@/assets/travel_book_images/page-08.png'),
        ],
        // pages: ['https://unsplash.com/it/foto/una-persona-in-piedi-su-una-montagna-coperta-di-neve-con-le-braccia-in-aria-uzfWPZjCRgo'],
      }),
      mounted() {
        window.addEventListener('keydown', (ev) => {
        const flipbook = this.$refs.flipbook
        if (!flipbook) return
        if (ev.keyCode === 37 && flipbook.canFlipLeft) flipbook.flipLeft()
        if (ev.keyCode === 39 && flipbook.canFlipRight) flipbook.flipRight()
        })
      },
    }
  </script>

  <style>
  .v-application .grey--text.text--darken-1 {
    color: black !important;
  }

.action-bar {
  width: 100%;
  height: 30px;
  padding: 22px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-bar .btn {
  font-size: 30px;
  color: #d7422b;
}

.action-bar .btn svg {
  bottom: 0;
}

.action-bar .btn:not(:first-child) {
  margin-left: 10px;
}

@media (hover: hover) {
.action-bar .btn:hover {
  color: #ff6a53;
  filter: drop-shadow(1px 1px 8px #aa5858);
  cursor: pointer;
}
}

@media screen and (max-width: 767px) {
.polygon {
  top: unset !important;
}
}

.action-bar .btn:active {
  filter: none !important;
}

.action-bar .btn.disabled {
  color: #bfbdbd;
  pointer-events: none;
}

.action-bar .page-num {
  font-size: 12px;
  margin-left: 10px;
}

.flipbook {
  width: 100%;
}

.page {
  top: unset !important;
}

.flipbook .viewport {
  width: 100% !important;
  height: 65vh !important;
}

.flipbook .bounding-box {
  box-shadow: 0 0 20px #000;
  top: unset !important;
}


</style>
